/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Store from "@ember-data/store";
import { action } from "@ember/object";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import { getGroupedBioExams } from "core/components/bio-exam-results/utils/groupedBioExams";
import BioExamOrder from "core/models/bio-exam-order";
import ErrorsService from "core/services/errors";
import { BufferedChangeset } from "ember-changeset/types";
import styles from "./index.module.css";
let PrescriptionBioExamEditionFormContent = (_class = class PrescriptionBioExamEditionFormContent extends Component {
  constructor(owner, args) {
    super(owner, args);
    _defineProperty(this, "styles", styles);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "errors", _descriptor2, this);
    _defineProperty(this, "labelFromLoinc", loinc => {
      return this.store.peekRecord("bio-exam-order", loinc).longLabel;
    });
    this.prescriptibleOrders = this.store.peekAll("bio-exam-order");
  }
  get orderedPrescriptibleOrders() {
    return getGroupedBioExams(this.prescriptibleOrders);
  }
  get today() {
    return new Date();
  }
  get selectedFrequency() {
    const fqcy = this.args.changeset.get("frequency");
    return fqcy;
  }
  get frequencyOptions() {
    return ["1-day", "1-week", "2-week", "1-month", "2-month", "3-month", "4-month", "5-month", "6-month", "1-year", "none"];
  }
  get validityOptions() {
    return ["Un mois", "Deux mois", "Trois mois", "Quatre mois", "Cinq mois", "Six mois", "Un an"];
  }
  onOrderAdded(value) {
    const loincs = [...(this.args.changeset.get("exams") || [])];
    loincs.push(value);
    this.args.changeset.set("exams", loincs);
  }
  onOrderRemoved(value) {
    const loincs = [...this.args.changeset.get("exams")];
    const indexToRemove = loincs.findIndex(loinc => loinc == value);
    loincs.splice(indexToRemove, 1);
    this.args.changeset.set("exams", loincs);
  }
  onFrequencyChanged(selectedValue) {
    const value = selectedValue;
    this.args.changeset.set("frequency", value);
  }
  updateAldRelatedComments(suggestion) {
    this.appendComment("aldRelatedComments", suggestion);
  }
  updateNonAldRelatedComments(suggestion) {
    this.appendComment("comments", suggestion);
  }
  appendComment(changesetKey, value) {
    const comments = this.args.changeset.get(changesetKey) || "";
    const newComments = comments.concat(`${value}\n`);
    this.args.changeset.set(changesetKey, newComments);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onOrderAdded", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onOrderAdded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onOrderRemoved", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onOrderRemoved"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onFrequencyChanged", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onFrequencyChanged"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateAldRelatedComments", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateAldRelatedComments"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateNonAldRelatedComments", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateNonAldRelatedComments"), _class.prototype), _class);
export { PrescriptionBioExamEditionFormContent as default };